import React from "react";
import * as ReactDOM from "react-dom";
import log from "loglevel";
import { Store } from "redux";
import { createBrowserHistory } from "history";
import { Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import "chartjs-adapter-moment";
import { Chart, registerables, _adapters } from "chart.js";

import { App } from "@app/components/App";
import { getInitialState, subscribe } from "@app/stores/persistStore";
import { configureStore } from "@app/stores/configureStore";
import { GlobalState } from "@app/models/state";
import { getIsAuthenticated } from "@auth/selectors";
import { Localisation } from "@localisation/index";
import { ConnectedIntlProvider } from "@localisation/components/ConnectedIntlProvider";

// Initialise react-dates
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

// Import the styles too
import "css-toggle-switch/dist/toggle-switch.css";
import "@styles/main.scss";

// Set the chart.js global styles.
Chart.defaults.font.family = "'Archivo', sans-serif";
Chart.defaults.color = "#212529";
Chart.defaults.font.size = 12;
const chartPaddingPlugin = {
    id: "legendPadding",
    beforeInit(chart: Chart) {
        // Get a reference to the original fit function
        const originalFit = chart.legend.fit;

        // Override the fit function
        chart.legend.fit = () => {
            // Call the original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in other answers
            this.height += 8;
        };
    },
};
Chart.register(...registerables, chartPaddingPlugin);

// Get the initial state from the store.
const globalState = getInitialState();

const history = createBrowserHistory();
const store: Store<GlobalState> = configureStore(history, globalState);

// Persist the store.
subscribe(store);

// Set the default logging level
log.setLevel("debug");

// Initialise react-intl
Localisation.initialiseReactIntl();

ReactDOM.render(
    <Provider store={store}>
        <ConnectedIntlProvider defaultRichTextElements={{
            a: (chunks) => <a>{chunks}</a>,
            p: (chunks) => <p>{chunks}</p>,
            strong: (chunks) => <strong>{chunks}</strong>,
            em: (chunks) => <em>{chunks}</em>,
            br: () => <br />,
        }}>
            <Router history={history}>
                <Route path="/" render={() => <App authenticated={getIsAuthenticated(store.getState())} />} />
            </Router>
        </ConnectedIntlProvider>
    </Provider>,
    document.getElementById("app"),
);
